/* (c) Copyright Frontify Ltd., all rights reserved. */

import { createFondueIcon } from '../createFondueIcon';

/**
 * @component @name ArrowBottomRight
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik04LjIyOSAxOC40NzhhLjc1Ljc1IDAgMTEwLTEuNWg3LjY4OUw1LjkzIDYuOTkyYS43NS43NSAwIDAxMS4wNi0xLjA2bDkuOTg5IDkuOTg3di03LjY5YS43NS43NSAwIDAxMS41IDB2MTAuMjV6Ii8+PC9zdmc+) - https://fondue-components.frontify.com/?path=/story/icons_icons--default&args=iconName:arrow-bottom-right
 * @see https://fondue-components.frontify.com/?path=/story/icons_icons--default - Documentation
 */
export const IconArrowBottomRight = createFondueIcon('ArrowBottomRight', [["path",{"fill":"currentColor","d":"M8.229 18.478a.75.75 0 110-1.5h7.689L5.93 6.992a.75.75 0 011.06-1.06l9.989 9.987v-7.69a.75.75 0 011.5 0v10.25z"}]]);
